// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const watchog: PokeData = {
  "id": 505,
  "name": "watchog",
  "height": 11,
  "weight": 270,
  "base_experience": 147,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "slam",
    "sand-attack",
    "tackle",
    "leer",
    "bite",
    "low-kick",
    "hypnosis",
    "confuse-ray",
    "focus-energy",
    "bide",
    "hyper-fang",
    "super-fang",
    "detect",
    "mean-look",
    "baton-pass",
    "crunch",
    "psych-up",
    "nasty-plot",
    "after-you",
    "rototiller"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "confuse-ray",
    "crunch",
    "rototiller",
    "supersonic",
    "splash",
    "tri-attack",
    "scary-face",
    "quick-attack",
    "refresh",
    "purification"
  ],
  "evolution_chain": {
    "id": 259,
    "item": null,
    "species": [
      {
        "name": "patrat",
        "order": 505,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "watchog",
        "order": 506,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 504,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 136,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
